import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import Modal from "./Modal";
import CopyRight from "./CopyRights";
import LoadingScreen from "./LoadingScreen";
import "./Projects.css";

const Drawings = () => {
  const [drawings, setDrawings] = useState([]);
  const [modalData, setModalData] = useState({}); // this use to get one drawing data to popup
  const [isModalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Track the loading state
  const [dataLoaded, setDataLoaded] = useState(false); // To control animation finish

  const openModal = (projectData) => {
    setModalData(projectData);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    const getDrawings = async () => {
      try {
        // await new Promise((resolve) => setTimeout(resolve, 3000)); // Simulate delay of 3 seconds
        await axios
          .get("/api/project/getDrawings/")
          .then((res) => {
            setDrawings(res.data.prj);
            console.log(res.data.message);
          })
          .catch((error) => {
            console.log("☠️ Error Detected : ", error.messasge);
          });
      } catch (error) {
        console.log("☠️ Error Detected : ", error.messasge);
      } finally {
        setIsLoading(false); // Stop the loading animation
        setDataLoaded(true); // Trigger the final 100% fill
      }
    };

    getDrawings();
  }, []);

  if (isLoading) {
    return <LoadingScreen isLoading={isLoading} dataLoaded={dataLoaded} />; // Show the loading animation while fetching data and Pass loading state to animation component
  }

  return (
    <div className="project-div">
      <div className="home-title">
        <div className="head-title">Drawings/Illustrations</div>
      </div>

      <div className="home-info-div">
        Welcome to my collection of drawings and illustrations, where creativity
        meets storytelling. Each piece is crafted with attention to detail, from
        character designs to immersive environments. My work explores a range of
        themes, blending different styles and techniques to bring ideas to life.
        I'm always experimenting and evolving, with every illustration being a
        step forward in my artistic journey.
      </div>

      <div className="projects-cards">
        {drawings.map((projectData) => (
          <div className="project-card" id="projectCard" key={projectData._id}>
            <div className="project-image-div">
              <img
                src={projectData.imgUrl}
                alt="project-image"
                className="project-image"
                onClick={() => openModal(projectData)}
                data-bs-toggle="modal"
                data-bs-target="#projectModal"
              />
            </div>
            <div className="project-details-div">
              <div className="tooltip-text-project">
                {projectData.projectTopic}
              </div>
              <div
                className="project-title"
                onClick={() => openModal(projectData)}
                data-bs-toggle="modal"
                data-bs-target="#projectModal"
              >
                {projectData.projectTopic}
              </div>
              <div className="project-created-date">
                {moment(projectData.createdAt).format("MMMM Do YYYY | h:mm a")}
              </div>
              <div className="project-created-date">
                {moment(projectData.createdAt, "YYYYMMDD").fromNow()}
              </div>
            </div>
          </div>
        ))}
      </div>

      <Modal isOpen={isModalOpen} onClose={closeModal} modalData={modalData} />

      <CopyRight />
    </div>
  );
};

export default Drawings;
